import { render, staticRenderFns } from "./Widget14_MiniProfitShare.vue?vue&type=template&id=12d1afd5&"
import script from "./Widget14_MiniProfitShare.vue?vue&type=script&lang=js&"
export * from "./Widget14_MiniProfitShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports